export default {
    name: "ButtonStylesMixin",

    methods: {
        buttonRoundnessStyle(value) {
            let roundnessValue = this.buttonRoundnessValue(value);

            return `border-radius: ${ roundnessValue }px !important;`
        },

        buttonRoundnessValue(value) {
            if (value === 0) {
                return 0;
            }

            if (value > 0 && value <= 25) {
                return 4;
            }

            if (value > 25 && value <= 50) {
                return 8;
            }

            if (value > 50 && value <= 75) {
                return 16;
            }

            if (value > 75 && value <= 100) {
                return 99;
            }
        },

        buttonShadowValue(value) {
            return value ? 2 : 0;
        }
    }
};